export const VALIDATION_MESSAGE = 'Address must be selected from provided list';